<template>
  <nav class="bottom-nav">

    <a href="#slide-1" class="nav-item">
      <i class="fa-regular fa-envelope-open"></i>
    </a>
    <a href="#slide-2" class="nav-item">
      <i class="fas fa-image"></i>
    </a>
    <a href="#slide-3" class="nav-item">
      <i class="fas fa-map-marker-alt"></i>
    </a>
    <a href="#slide-4" class="nav-item">
      <i class="fas fa-calendar-alt"></i>
    </a>
    <!-- <a href="#q&a" class="nav-item">
      <i class="fas fa-comment-dots"></i>
    </a> -->
  </nav>
</template>

<script>
export default {
  name: "BottomNav",
};
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  padding: 5px 10px;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.nav-item {
  color: #fefefe;
  font-size: 1.2rem;
  padding: 10px;
  border-radius: 10px;
  background: linear-gradient(to bottom right, #F6C2B7, #F3E2DB);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  transition: background 0.2s ease;
}

.nav-item:hover {
  background-color: #bca8c6;
}
</style>
